import { useCableStatusStore } from '@/common/stores/cableStatus'

const CableConnectionTag = () => {
  const status = useCableStatusStore((state) => state.status)

  if (status === 'idle') return null

  if (status === 'connected') {
    return (
      <span className="flex items-center gap-1 text-[10px] font-normal text-white-300 shrink-0">
        <span className="w-1.5 h-1.5 rounded-full bg-valid animate-pulse" />
        Atualizado em tempo real
      </span>
    )
  }

  if (status === 'connecting') {
    return (
      <span className="flex items-center gap-1 text-[10px] font-normal text-white-300 shrink-0">
        <span className="w-1.5 h-1.5 rounded-full bg-yellow-400 animate-pulse" />
        Conectando…
      </span>
    )
  }

  return (
    <span className="flex items-center gap-1 text-[10px] font-semibold text-danger-soft shrink-0">
      <span className="w-1.5 h-1.5 rounded-full bg-danger-soft animate-pulse" />
      Sem conexão — reconectando…
    </span>
  )
}

export default CableConnectionTag
